import React, { createContext, useContext, useState } from 'react';

const AUTH_KEY = 'tas_operator';
const PASSWORD = '123456';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [operator, setOperator] = useState(() => {
    return localStorage.getItem(AUTH_KEY) || null;
  });

  function login(traverser, password) {
    if (password !== PASSWORD) return false;
    localStorage.setItem(AUTH_KEY, traverser);
    setOperator(traverser);
    return true;
  }

  function logout() {
    localStorage.removeItem(AUTH_KEY);
    setOperator(null);
  }

  return (
    <AuthContext.Provider value={{ operator, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
